/**
 * Show the mobile version link banner if the user is viewing the site on a
 * mobile device, or alternatively automatically redirect the browser to the
 * mobile version.
 * @constructor
 * @param {string} componentId
 * @param {boolean} autoRedirectToMobileSite
 * @extends {Foundation.Component}
 */
Foundation.MobileDetectComponent = function (componentId, autoRedirectToMobileSite) {
    Foundation.Component.call(this, componentId);
    
    this.mobileLink = this.view.find("a[media~=handheld]");
    this.mobileLink.click(this.switchToMobileSite.bind(this, true));
    
    this.userMobilePrefCookie = new Foundation.Cookie("foundation-mobile");
    this.userMobilePrefCookie.ttl = 365 * 24 * 60 * 60;
    
    // If the user has #fromMobile set in their URL, then they got to the desktop
    // site by clicking on the "view in desktop site" link in the footer of the
    // mobile site. So let's set their mobile site preference to be the desktop
    // version of the site.
    if (window.location.hash === "#fromMobile") {
        this.userMobilePrefCookie.setValueAndSave("desktop");
    }
    
    // If this is what we consider to be a mobile device, then either redirect
    // to the mobile site or make this component visible to the user.
    if (Foundation.Environment.isMobile()) {
        var userPrefersMobileSite = this.userMobilePrefCookie.getValue() === "mobile" ? true : false;
        var userPrefersDesktopSite = this.userMobilePrefCookie.getValue() === "desktop" ? true : false;
        
        if ((autoRedirectToMobileSite && !userPrefersDesktopSite) || userPrefersMobileSite) {
            this.switchToMobileSite();
        }
        else {
            this.view.show();
        }
    }
};
Foundation.inherit(Foundation.MobileDetectComponent, Foundation.Component);

/**
 * Switch the user to the mobile version of this page.
 * @param {boolean=} setMobilePrefCookie Save the user's preference for viewing the mobile site in a cookie.
 * @param {jQuery.Event=} e
 */
Foundation.MobileDetectComponent.prototype.switchToMobileSite = function (setMobilePrefCookie, e) {
    if (e) e.preventDefault();
    
    if (setMobilePrefCookie) {
        this.userMobilePrefCookie.setValueAndSave("mobile");
    }
    
    // Redirect the user to the mobile verstion of this page. Make sure we're
    // not on the mobile domain however, so as to avoid a redirect loop.
    if (!Foundation.domainIsMobile()) {
        var mobileUrl = /** @type {string} */ (this.mobileLink.attr("href"));
        (new Foundation.URL(mobileUrl)).go();
    }
};

// ---------------------------------------------------------------------

window["Foundation"]["MobileDetectComponent"] = Foundation.MobileDetectComponent;

// ---------------------------------------------------------------------
